import { AfterContentInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IAddressModel, IAddressSearchModel, ICountryDtoModel, IVerifyAddressDtoRequest, IVerifyAddressDtoResponse, LocationService, ILookUpType, RolePermissionService, ApplicationContextService } from 'lib-core-shared';
import { BehaviorSubject } from 'rxjs';
import { ModalComponent } from '../communication/modal/modal.component';
import { ComponentBaseDirective, Mode } from '../directives/component.directive';
import { AddressViewModel } from '../viewModels/address.viewmodel';

export enum AddressSearchMode {
  Normal,
  RetryContinue,
  Suggestion
}
@Component({
  selector: 'app-address-search-box',
  templateUrl: './address-search-box.component.html',
  styleUrls: ['./address-search-box.component.scss']
})
export class AddressSearchBoxComponent extends ComponentBaseDirective implements AfterContentInit, OnChanges {
  public viewMode: AddressSearchMode = AddressSearchMode.Normal;
  public vm: AddressViewModel;
  public suggestedAddress!: IAddressModel;
  @Input() public isExternalVerifyControlled = false;
  @Output() public allowEditFormEmitter = new EventEmitter<boolean>();
  @Output() public isAddressVerifiedOrOverruled = new EventEmitter<boolean>();
  public address: IAddressModel | undefined;
  public overrideAllowEditForm: boolean = true;
  public countryLoaded: boolean = false;
  public searchFormGroup: FormGroup;
  @Input() public countries!: ICountryDtoModel[];
  public countriesWithPostCode: string[] = [];
  @Input() verifyAddress$ = new BehaviorSubject<boolean>(false);
  @Input() parentFormSubmitted: boolean = false;
  public get ViewModeEnum() {
    return AddressSearchMode;
  }
  public verificationErrorLoading: string = 'Error verifying address';
  public verificationFailedModalRef!: NgbModalRef
  @ViewChild('verificationFailedModal') public verificationFailedModal!: ElementRef;

  @Input() public formGroup: FormGroup;
  @Output() public formGroupEmitter = new EventEmitter<FormGroup>();
  @Input() public allowEditForm: boolean = false;
  @Input() public allowAddressNameField: boolean = true;
  @Output() public countrySelected: EventEmitter<ICountryDtoModel> = new EventEmitter<ICountryDtoModel>();
  @Input() public countryLookup!: ILookUpType;
  @Output() public isContactNumberVerified: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public resetParentForm: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() contactNumberRequired?: boolean;

  public countryValidation(country: ICountryDtoModel) {
    this.formGroup.controls.country.setValue(country);
    this.formGroup.controls.countryCode?.setValue(country.code);
    this.formGroup.controls.countryName?.setValue(country.name);

    const countryResult = this.countriesWithPostCode.filter(x => country?.code === x);
    if (!countryResult?.length) {
      this.formGroup.controls.postalCode.clearValidators();
    } else {
      this.formGroup.controls.postalCode.setValidators([Validators.required]);
    }

    this.countrySelected.emit(country);
    this.countryLookup = country;
  }

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public roleService: RolePermissionService,
    public formBuilder: FormBuilder,
    private readonly locationService: LocationService,
    public modalService: NgbModal,
    public applicationContext: ApplicationContextService) {
    super(activatedRoute, router, roleService, applicationContext);
    this.vm = new AddressViewModel(formBuilder);
    this.formGroup = this.vm.form();
    this.searchFormGroup = this.formBuilder.group({
      searchTerm: [''],
      country: [null, Validators.required]
    }) as FormGroup;

    

  
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    const latest = changes['allowEditForm'];
    if (latest && latest.currentValue) {
      this.allowEditFormEmitter.emit(latest.currentValue as boolean);
    }

    if(changes.parentFormSubmitted?.currentValue == true){
      this.verifyAddress();
    }
  }

  ngAfterContentInit(): void {

    if(this.countries == undefined){
      this.activatedRoute.data.subscribe((payload) => {
        this.countries = payload.customerData.countries as ICountryDtoModel[];
        this.countriesWithPostCode = payload.customerData.countriesWithPostCode as string[]
        this.assignDefaultCountry();
      });
    }else{
      this.assignDefaultCountry();
    }

    this.allowEditForm = this.mode === Mode.edit;
    if (this.mode === Mode.edit) {
      this.overrideAllowEditForm = false;
    }

    if (this.verifyAddress$) {
      this.verifyAddress$.subscribe(x => this.verifyAddress(x));
    }
  }

  assignDefaultCountry(): void {

    let defaultCountry = {code: 'GB', name: 'United Kingdom'} as ILookUpType; //needs to use an environment variable

    if (this.countryLookup) {
      defaultCountry = this.countryLookup;
    }
    
    const countryFound = this.countries?.filter(x => x.name.toLocaleLowerCase() === defaultCountry?.name?.toLocaleLowerCase());
    if (countryFound?.length) {
      this.searchFormGroup.patchValue({
        searchTerm: [''],
        country: countryFound[0]
      });
      this.countryValidation(countryFound[0]);
    }
    this.countryLoaded = true;
  }

  public locationSelected(address: IAddressModel) {
    this.vm.formMapping.toForm(address, this.formGroup, this.countryLookup);
    this.allowEditForm = true;
    this.overrideAllowEditForm = false;
  }

  public retry(retry: boolean | any) {
    if (retry) {
      this.resetParentForm.emit(true)
      this.verificationFailedModalRef.close()
    } else {
      this.vm.formMapping.toForm(this.address, this.formGroup);
      this.formGroupEmitter.emit(this.formGroup);
      this.isAddressVerifiedOrOverruled.emit(true);
      this.viewMode = AddressSearchMode.Normal;
    }
  }

  public overrideRule(result: IAddressSearchModel[]) {
    this.overrideAllowEditForm = result.length === 0;
  }
  public get country(): ICountryDtoModel {
    return this.searchFormGroup?.controls?.country?.value ? this.searchFormGroup.controls.country.value : '';
  }

  public showAddress() {
    this.overrideAllowEditForm = false;
    this.allowEditForm = true
  }

  public confirmSuggestion(choice: IAddressModel | any) {
    this.vm.formMapping.toForm(choice, this.formGroup);
    this.isAddressVerifiedOrOverruled.emit(true);
    this.formGroupEmitter.emit(this.formGroup);
   
    this.formGroup.enable();
    this.searchFormGroup.enable();
    this.viewMode = AddressSearchMode.Normal;
  }

  public verifyAddress(allow = true): void {
    if (allow) {
      this.address = this.vm.formMapping.toApplicationModel(this.formGroup, this.country);
      const addressVerify = {
        addressLine1: this.address?.addressLine1,
        addressLine2: this.address?.addressLine2,
        countyState: this.address?.countyState,
        townCity: this.address?.townCity,
        country: this.address?.countryName,
        countryCode: this.address?.countryCode,
        postalCode: this.address?.postalCode
      } as IVerifyAddressDtoRequest;
      this.isBusy = true;
      this.locationService.verify(addressVerify).subscribe((response: IVerifyAddressDtoResponse) => {
        if (response.qualityIndex === 'A') {
          this.formGroup.controls.isVerified.setValue(true);
          this.formGroupEmitter.emit(this.formGroup);
          this.isAddressVerifiedOrOverruled.emit(true);
          this.viewMode = AddressSearchMode.Normal;
        }
        else if (response.qualityIndex === 'B') {
          this.formGroup.controls.isVerified.setValue(false);
          this.isAddressVerifiedOrOverruled.emit(false);
          this.formGroup.disable();
          this.searchFormGroup.disable();
          this.viewMode = AddressSearchMode.Suggestion;
          this.suggestedAddress = this.vm.addressRequestMapping.toSourceOneModel(response);

        } else {
          this.formGroup.controls.isVerified.setValue(false);
          this.isAddressVerifiedOrOverruled.emit(false);
          this.openUnverifiedAddressModal();

          this.viewMode = AddressSearchMode.RetryContinue;
        }
        this.isBusy = false;
      }, (e: any) => {
        this.isBusy = false;
        //this.reportError(e, this.verificationErrorLoading); - it's pointless reporting the error as the user is then stuck, instead alert user that the address couldn't be verified
        this.isAddressVerifiedOrOverruled.emit(false);
      });
    }
  }

  public openUnverifiedAddressModal() {
    this.verificationFailedModalRef = this.modalService.open(this.verificationFailedModal);
  }

  checkContactNumberIsVerified(e: any) {

    console.log(e)
    this.isContactNumberVerified.emit(e);

  }

  searchLocationComponentError() {
    this.showAddress();
  }
}
